/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@blueprintjs/core");
/**
 * Convert a position to a placement.
 * @param position the position to convert
 */
function positionToPlacement(position) {
    switch (position) {
        case core_1.Position.TOP_LEFT:
            return "top-start";
        case core_1.Position.TOP:
            return "top";
        case core_1.Position.TOP_RIGHT:
            return "top-end";
        case core_1.Position.RIGHT_TOP:
            return "right-start";
        case core_1.Position.RIGHT:
            return "right";
        case core_1.Position.RIGHT_BOTTOM:
            return "right-end";
        case core_1.Position.BOTTOM_RIGHT:
            return "bottom-end";
        case core_1.Position.BOTTOM:
            return "bottom";
        case core_1.Position.BOTTOM_LEFT:
            return "bottom-start";
        case core_1.Position.LEFT_BOTTOM:
            return "left-end";
        case core_1.Position.LEFT:
            return "left";
        case core_1.Position.LEFT_TOP:
            return "left-start";
        default:
            return assertNever(position);
    }
}
exports.positionToPlacement = positionToPlacement;
function assertNever(x) {
    throw new Error("Unexpected position: " + x);
}

//# sourceMappingURL=popoverMigrationUtils.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/labs/dist/components/popover/popoverMigrationUtils.js
// module id = 882
// module chunks = 0